// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.szh-menu {
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
  width: -moz-max-content;
  width: max-content;
  z-index: 100;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #fff;
}
.szh-menu:focus {
  outline: none;
}
.szh-menu__arrow {
  box-sizing: border-box;
  width: 0.75rem;
  height: 0.75rem;
  background-color: #fff;
  border: 1px solid transparent;
  border-left-color: rgba(0, 0, 0, 0.1);
  border-top-color: rgba(0, 0, 0, 0.1);
  z-index: -1;
}
.szh-menu__arrow--dir-left {
  right: -0.375rem;
  transform: translateY(-50%) rotate(135deg);
}
.szh-menu__arrow--dir-right {
  left: -0.375rem;
  transform: translateY(-50%) rotate(-45deg);
}
.szh-menu__arrow--dir-top {
  bottom: -0.375rem;
  transform: translateX(-50%) rotate(-135deg);
}
.szh-menu__arrow--dir-bottom {
  top: -0.375rem;
  transform: translateX(-50%) rotate(45deg);
}
.szh-menu__item {
  cursor: pointer;
}
.szh-menu__item:focus {
  outline: none;
}
.szh-menu__item--hover {
  background-color: #ebebeb;
}
.szh-menu__item--focusable {
  cursor: default;
  background-color: inherit;
}
.szh-menu__item--disabled {
  cursor: default;
  color: #aaa;
}
.szh-menu__group {
  box-sizing: border-box;
}
.szh-menu__radio-group {
  margin: 0;
  padding: 0;
  list-style: none;
}
.szh-menu__divider {
  height: 1px;
  margin: 0.5rem 0;
  background-color: rgba(0, 0, 0, 0.12);
}

.szh-menu-button {
  box-sizing: border-box;
}

.szh-menu {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  color: #212529;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.133), 0 0.6px 2px rgba(0, 0, 0, 0.1);
  min-width: 10rem;
  padding: 0.5rem 0;
}
.szh-menu__item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0.375rem 1.5rem;
}
.szh-menu-container--itemTransition .szh-menu__item {
  transition-property: background-color, color;
  transition-duration: 0.15s;
  transition-timing-function: ease-in-out;
}
.szh-menu__item--type-radio {
  padding-left: 2.2rem;
}
.szh-menu__item--type-radio::before {
  content: "○";
  position: absolute;
  left: 0.8rem;
  top: 0.55rem;
  font-size: 0.8rem;
}
.szh-menu__item--type-radio.szh-menu__item--checked::before {
  content: "●";
}
.szh-menu__item--type-checkbox {
  padding-left: 2.2rem;
}
.szh-menu__item--type-checkbox::before {
  position: absolute;
  left: 0.8rem;
}
.szh-menu__item--type-checkbox.szh-menu__item--checked::before {
  content: "✔";
}
.szh-menu__submenu > .szh-menu__item {
  padding-right: 2.5rem;
}
.szh-menu__submenu > .szh-menu__item::after {
  content: "❯";
  position: absolute;
  right: 1rem;
}
.szh-menu__header {
  color: #888;
  font-size: 0.8rem;
  padding: 0.2rem 1.5rem;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./../../../node_modules/@szhsin/react-menu/dist/index.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,qCAAqC;EACrC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,0EAA0E;EAC1E,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":["@charset \"UTF-8\";\n.szh-menu {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  box-sizing: border-box;\n  width: max-content;\n  z-index: 100;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n}\n.szh-menu:focus {\n  outline: none;\n}\n.szh-menu__arrow {\n  box-sizing: border-box;\n  width: 0.75rem;\n  height: 0.75rem;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-left-color: rgba(0, 0, 0, 0.1);\n  border-top-color: rgba(0, 0, 0, 0.1);\n  z-index: -1;\n}\n.szh-menu__arrow--dir-left {\n  right: -0.375rem;\n  transform: translateY(-50%) rotate(135deg);\n}\n.szh-menu__arrow--dir-right {\n  left: -0.375rem;\n  transform: translateY(-50%) rotate(-45deg);\n}\n.szh-menu__arrow--dir-top {\n  bottom: -0.375rem;\n  transform: translateX(-50%) rotate(-135deg);\n}\n.szh-menu__arrow--dir-bottom {\n  top: -0.375rem;\n  transform: translateX(-50%) rotate(45deg);\n}\n.szh-menu__item {\n  cursor: pointer;\n}\n.szh-menu__item:focus {\n  outline: none;\n}\n.szh-menu__item--hover {\n  background-color: #ebebeb;\n}\n.szh-menu__item--focusable {\n  cursor: default;\n  background-color: inherit;\n}\n.szh-menu__item--disabled {\n  cursor: default;\n  color: #aaa;\n}\n.szh-menu__group {\n  box-sizing: border-box;\n}\n.szh-menu__radio-group {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.szh-menu__divider {\n  height: 1px;\n  margin: 0.5rem 0;\n  background-color: rgba(0, 0, 0, 0.12);\n}\n\n.szh-menu-button {\n  box-sizing: border-box;\n}\n\n.szh-menu {\n  user-select: none;\n  color: #212529;\n  border: none;\n  border-radius: 0.25rem;\n  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.133), 0 0.6px 2px rgba(0, 0, 0, 0.1);\n  min-width: 10rem;\n  padding: 0.5rem 0;\n}\n.szh-menu__item {\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 0.375rem 1.5rem;\n}\n.szh-menu-container--itemTransition .szh-menu__item {\n  transition-property: background-color, color;\n  transition-duration: 0.15s;\n  transition-timing-function: ease-in-out;\n}\n.szh-menu__item--type-radio {\n  padding-left: 2.2rem;\n}\n.szh-menu__item--type-radio::before {\n  content: \"○\";\n  position: absolute;\n  left: 0.8rem;\n  top: 0.55rem;\n  font-size: 0.8rem;\n}\n.szh-menu__item--type-radio.szh-menu__item--checked::before {\n  content: \"●\";\n}\n.szh-menu__item--type-checkbox {\n  padding-left: 2.2rem;\n}\n.szh-menu__item--type-checkbox::before {\n  position: absolute;\n  left: 0.8rem;\n}\n.szh-menu__item--type-checkbox.szh-menu__item--checked::before {\n  content: \"✔\";\n}\n.szh-menu__submenu > .szh-menu__item {\n  padding-right: 2.5rem;\n}\n.szh-menu__submenu > .szh-menu__item::after {\n  content: \"❯\";\n  position: absolute;\n  right: 1rem;\n}\n.szh-menu__header {\n  color: #888;\n  font-size: 0.8rem;\n  padding: 0.2rem 1.5rem;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
